import { FC } from "react";
import { Section } from "@/components/Html/Section";

interface Props {
  title: string;
  description: string;
}

export const Card: FC<Props> = ({ title, description }) => {
  return (
    <Section className="min-h-[300px] w-full rounded-[24px] bg-[#FFF5F6] p-[24px] md:w-[calc((100%-2*16px)/3)]">
      <p className="mb-[16px] text-[22px]">{title}</p>
      <p>{description}</p>
    </Section>
  );
};
